__turbopack_context__.v({
  "container": "savings-calculator-module-scss-module__Bt9mJW__container",
  "copy": "savings-calculator-module-scss-module__Bt9mJW__copy",
  "form": "savings-calculator-module-scss-module__Bt9mJW__form",
  "supportingText": "savings-calculator-module-scss-module__Bt9mJW__supportingText",
});
